import gql from 'graphql-tag';
import { COACHING_COMMITMENT_TYPE } from './CoachingCommitmentType.gql';

export const EDIT_COACHING_COMMITMENT = gql`
  ${COACHING_COMMITMENT_TYPE}
  mutation updateCoachingCommitment($description: String, $id: ID!, $title: String) {
    updateCoachingCommitment(description: $description, id: $id, title: $title) {
      coachingCommitment {
        ...CoachingCommitmentType
      }
    }
  }
`;
